import * as React from 'react';
import * as styled from './styled';
import {v4 as uuid} from 'uuid';
import {DragDropContext, Droppable, DropResult} from 'react-beautiful-dnd';
import {useFormikContext} from 'formik';
import {TaskObject, BlockType} from 'api/task/types';
import {Separator, ControlObject} from 'components/Separator';
import {Blocks} from './components/Blocks';
import reorder from 'helpers/reorder';

/**
 * The content editor of the task.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Content(): React.ReactElement {
  const {
    values,
    setFieldValue,
  } = useFormikContext<Partial<TaskObject>>();
  console.log('values', values);

  /**
   * Render blocks of content.
   * @return {JSX.Element}
   */
  function renderBlocks(): JSX.Element {
    const blocks = values.content?.blocks || [];
    console.log('blocks', blocks);

    /**
     * Render separator.
     * @return {JSX.Element}
     */
    function renderSeparator(): JSX.Element {
      const controls: ControlObject<BlockType>[] = [
        {type: BlockType.Test, label: 'Тест'},
        {type: BlockType.AutoCheck, label: 'Вопрос с автопроверкой'},
        {type: BlockType.FreeAnswer, label: 'Задание со свободным ответом'},
        {type: BlockType.Classification, label: 'Классификация'},
        {type: BlockType.Accordance, label: 'Задание на соответствие'},
      ];

      /**
       * The control click event handler.
       * @param {ControlObject<BlockType>} control
       * @return {void}
       */
      function handleControlClick(
          control: ControlObject<BlockType>,
      ): void {
        setFieldValue(
          'content.blocks',
          [...blocks, {
            id: uuid(),
            type: control.type,
            question: '',
            score: 0,
          }],
        );
      }

      return (
        <Separator
          controls={controls}
          onControlClick={handleControlClick}
        />
      );
    }

    /**
     * The drag end event handler.
     * @param {DropResult} result
     */
    function handleDragEnd(result: DropResult): void {
      if (!result.destination) return;

      const from = result.source;
      const to = result.destination;

      setFieldValue(
        'content.blocks',
        reorder(blocks, from.index, to.index),
      );
    }

    return (
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="blocks">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              <Blocks blocks={blocks} />
              {renderSeparator()}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  return (
    <styled.Wrapper>
      {renderBlocks()}
    </styled.Wrapper>
  );
}
